import { makeContextModule } from '@cian/react-utils';

import type { IBank } from '../types/bank';
import type { TFiltersDefaults } from '../types/filtersDefaults';
import type { IPromo } from '../types/promos';

export interface IMortgageCalculatorContext {
  filtersDefaults: TFiltersDefaults;
  banks: IBank[];
  mortgagePromos: IPromo[];
  mortgageSeoPageUrl: string | undefined;
  fromDeveloperMinPrice: number;
  fromDeveloperMaxPrice: number;
}

const {
  Context: { Provider: MortgageCalculatorContextProvider },
  useContext: useMortgageCalculatorContext,
} = makeContextModule<IMortgageCalculatorContext>({
  contextName: 'MortgageCalculatorContext',
});

export { MortgageCalculatorContextProvider, useMortgageCalculatorContext };
